/**
 * Defines some basic string operations
 */
export const Strings = {
    Empty: '',
};
//# sourceMappingURL=Strings.js.map